export default "__VITE_ASSET__B7n8kydo__"